import BgNsPrice from '@britishgasenergy/react-nucleus/dist/nuc-components/NsPrice';

import { poundsToPence } from 'utils/currency';

type NsPriceProps = {
  amount?: number;
  showDecimal?: boolean;
  negative?: boolean;
};

export const NsPrice = ({ amount, showDecimal, negative }: NsPriceProps) => {
  const pence = poundsToPence(amount);

  return (
    <BgNsPrice pence={pence} showDecimal={showDecimal} negative={negative} />
  );
};
